window.REBASE = window.REBASE || {};
REBASE.theme = {};

(function($) {
  $(function() {
    REBASE.theme.predictiveSearch = {
      formID: 'header-search-form',
      resultsID: 'header-search-results',
      query: '',
      requestOptions: {
        types: ['product'],
        limit: 4,
        unavailable_products: "bury",
        fields: 'title,variants.title,product_type,tag',
      },

      _init: function() {

        REBASE.theme.predictiveSearch._bindEvents();
      },

      _bindEvents: function() {
        var inputSelector = '#'+ REBASE.theme.predictiveSearch.formID + ' input[name="q"]';

        // setup debounced listener on form input change
        $(document).on('keyup', inputSelector, _.debounce(REBASE.theme.predictiveSearch._handleTextInput, 250));
      },

      _handleTextInput: function(e) {
        REBASE.theme.predictiveSearch.query = e.target.value;

        if ( REBASE.theme.predictiveSearch.query != '' ) {
          REBASE.theme.predictiveSearch._handleQueryRequest(REBASE.theme.predictiveSearch.query)
        } else {
          console.log('emptied the query input')
          $('#'+REBASE.theme.predictiveSearch.resultsID).html('')
        }
      },

      _handleQueryRequest: function(query) {
        $.getJSON("/search/suggest.json", {
          s: REBASE.theme.predictiveSearch.query + ' AND -"Garment Journey Only" AND -"search-excluded" AND -"onsale-excluded"',
          resources: REBASE.theme.predictiveSearch.requestOptions
        }).done(REBASE.theme.predictiveSearch._handleQueryResponse);
      },

      _sendGTagEvent: function(products) {
        var total_value = products.reduce(function(sum, prod){ return sum + parseFloat(prod.price)}, 0);
        var items = products.map( function(prod) { return { id: prod.id, 'google_business_vertical': 'retail'} });

        if ( typeof gtag === 'function' ) {
          gtag('event','view_search_results', {
            'value': total_value,
            'items': items
          });
        }
      },

      _handleQueryResponse: async function(response) {
        var resultsHTML = '';
        try {
          if ( response.resources.results.products.length ) {
            for (let prod of response.resources.results.products) {
              const prod_url_parts = prod.url.split('?');
              const clean_product_url = prod_url_parts[0];
              resultsHTML +=  '<a href="'+ prod.url +'" class="search-result column column--xs-6 column--md-3">';
              resultsHTML +=    '<div class="search-result__image">';
              resultsHTML +=      '<img src="' + prod.image + '" />';
              resultsHTML +=    '</div>';
              resultsHTML +=    '<div class="search-result__info">';
              resultsHTML +=      '<h4>'+prod.title+'</h4>';
              if(!prod.available){
                resultsHTML += '<span class="product__price product__price--alt">Sold Out</span>';
              }else if ( prod.type != 'Handbags' ) {
                let productResponse = await fetch(`${clean_product_url}?view=prices`);
                if(productResponse.ok){
                  let productResponseJSON = await productResponse.json();
                  resultsHTML += '<span>' + productResponseJSON?.price?.money_without_trailing_zeros + '</span>';
                } else {
                  console.error("Unable to fetch pricing data for search result", prod);
                }
              }
              resultsHTML +=    '</div>';
              resultsHTML +=  '</a>';
            };
            resultsHTML +=  '<button class="btn btn--small btn--plain center" type="submit" class="search-result column column--xs-12">View More</button>'
            $('#'+REBASE.theme.predictiveSearch.resultsID).html(resultsHTML);

            REBASE.theme.predictiveSearch._sendGTagEvent(response.resources.results.products);
          } else {
            $('#'+REBASE.theme.predictiveSearch.resultsID).html('');
          }
        } catch(e) {
          console.error(e)
        }
      }
    }

    REBASE.theme.predictiveSearch._init();
  });
})(jQuery)
